import React from 'react'
import isNil from 'lodash/isNil'
import { LKButton } from 'loankeeper-common/components'

const getIconComponent = (getIconConfig) => (props) => {
  const config = getIconConfig(props.value)
  if (isNil(config)) {
    return null
  }

  return <LKButton alias={typeof config === 'string' ? config : config.alias} />
}

export default getIconComponent
